import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { isMobile } from '../../../../lib/getDeviceSize';

interface Props {
  classes: any;
}

const styles = {
  card: {
    margin: '0 auto',
    marginBottom: 0,
    maxWidth: isMobile() ? 350 : 640,
  },
  cardContent: {
    padding: '45px 30px 0 !important',
  },
};

class CompsEmptyBlock extends React.Component<Props> {
  render() {
    return (
      <Card className={this.props.classes.card}>
        <CardContent className={this.props.classes.cardContent}>
          <p
            style={{
              color: '#555555',
              fontSize: 16,
              lineHeight: '22px',
              textAlign: 'center',
            }}
          >
            Oops! We couldn't find any comps matching your search.
            <div>
              {isMobile()
                ? 'Try adjusting your preferences by tapping the button below.'
                : 'Try adjusting your preferences above.'}
            </div>
          </p>
          <div style={{ marginBottom: -5, paddingTop: 15 }}>
            <img src={'/static/img/tools/toriibot_stop.svg'} />
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(CompsEmptyBlock);
